import NoContent from "../common/NoContent";
import Batch from "./Batch";
import { useOutletContext } from "react-router-dom";

export default function Batches() {
    const { batches, setBatches } = useOutletContext();

    return (
        <div className="flex-1 min-h-0 overflow-y-auto flex flex-column gap-2 p-2">
            {batches?.length ? batches.map((batch) => <Batch key={batch?.id} {...batch} setBatches={setBatches} />) : <NoContent />}
        </div>
    );
}
